import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b5150f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-chip" }, null, -1))
const _hoisted_3 = { class: "card-number" }
const _hoisted_4 = { class: "card-exp" }
const _hoisted_5 = { class: "card-holder" }
const _hoisted_6 = ["src"]

import { PaymentMethod } from '@/gp/GroupAdminModel'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentCard',
  props: {
    paymentMethod: {}
  },
  setup(__props: any) {

const props = __props;



const logos: any = { // 'any' prevents TS from complaining about arbitrary string as index
  "Visa": new URL('@/assets/logos/Visa.svg', import.meta.url).href,
  "Mastercard": new URL('@/assets/logos/Mastercard.png', import.meta.url).href,
  "Discover": new URL('@/assets/logos/Discover.png', import.meta.url).href,
  "AmericanExpress": new URL('@/assets/logos/AmericanExpress.png', import.meta.url).href,
}

const logoRef = computed(() => logos[props.paymentMethod.brand ?? ''])


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, "xxxx xxxx xxxx " + _toDisplayString(props.paymentMethod.lastDigits), 1),
    _createElementVNode("div", _hoisted_4, "exp " + _toDisplayString(props.paymentMethod.expirationDate?.toFormat('MM/yy')), 1),
    _createElementVNode("div", _hoisted_5, _toDisplayString(props.paymentMethod.billingName), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["card-logo", props.paymentMethod.brand])
    }, [
      _createElementVNode("img", { src: logoRef.value }, null, 8, _hoisted_6)
    ], 2)
  ]))
}
}

})